import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../../lib/api";
import { Section, Eyebrow, FadeIn } from "../../components/public/Section";
import { PageHero } from "./About";
import { Sparkles } from "lucide-react";

export default function Menus() {
  const [params] = useSearchParams();
  const [cats, setCats] = useState([]);
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(params.get("cat") || "indian");

  useEffect(() => {
    Promise.all([api.get("/public/menu-categories"), api.get("/public/menu-items")]).then(([a, b]) => {
      setCats(a.data); setItems(b.data);
    });
  }, []);

  const filtered = items.filter(i => i.category_slug === active);

  return (
    <>
      <PageHero title="Menus" subtitle="Fifteen cuisines · curated, plated and served with theatre." image="https://images.unsplash.com/photo-1680993032090-1ef7ea9b51e5?auto=format&fit=crop&w=2000&q=80" />
      <Section>
        <Eyebrow>Multi-Cuisine Atelier</Eyebrow>
        <div className="overflow-x-auto no-scrollbar -mx-4 px-4">
          <div className="flex gap-2 min-w-max pb-2">
            {cats.map(c => (
              <button
                key={c.id}
                onClick={() => setActive(c.slug)}
                className={`px-5 py-3 text-xs tracking-[0.25em] uppercase font-semibold border transition ${active === c.slug ? "bg-navy-900 text-gold border-navy-900" : "border-navy-900/15 hover:border-gold hover:text-gold"}`}
                data-testid={`menu-tab-${c.slug}`}
              >
                {c.name}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {filtered.map((i, idx) => (
            <FadeIn key={i.id} delay={idx * 0.03}>
              <div className="border border-navy-900/10 bg-white p-6 hover:border-gold transition" data-testid={`menu-item-${i.id}`}>
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <div className="serif text-xl">{i.name}</div>
                    {i.description && <div className="text-navy-900/60 text-sm mt-1">{i.description}</div>}
                  </div>
                  {i.is_signature && <span className="bg-gold/15 text-gold-600 text-[9px] tracking-[0.2em] uppercase px-2 py-1 font-bold flex items-center gap-1"><Sparkles size={10} />Signature</span>}
                </div>
              </div>
            </FadeIn>
          ))}
          {filtered.length === 0 && <div className="text-navy-900/60 col-span-full py-12 text-center">More dishes are being plated in this section.</div>}
        </div>
      </Section>
    </>
  );
}
